import { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Page,
  Msg,
  LoadMore,
  Toast,
  Panel,
  PanelBody,
  MediaBox
} from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import useList from 'hooks/useList';
import CommonFns from 'functions/common.ts';
import Util from 'lib/util.js';

function EcnList(props) {
  const Config = {
    purchase: {
      apiPath: '/vecn/getPageList',
      enumMainKey: '',
      companyNameKey: 'innerVendorName',
      detailLink: '/mp/purchase/ecn/detail',
      searchBarPlaceholder: '供应商编码/名称、报告编码',
      tabs: ['全部', '待R&D工程', '待质量管理', '待IQC', '已审核', '已退回'],
      countApi: '/vecn/count',
      arrEnumField: [
        {
          mainKey: 'B02_Ecn_Report_Status',
          subKey: 'reportStatus',
          value: 'reportStatusName'
        }
      ],
      countTransform: (data, self) => {
        let { [1]: a, [2]: b, [4]: c, [6]: d, [9]: f } = data;
        setCount([undefined, f, a, b, c, d]);
      },
      tabConfig: [
        undefined, //全部
        [9], //已退回
        [1], // 待R&D工程
        [2], //待质量管理
        [4], //待IQC
        [6] //已审核
      ]
    },
    sale: {
      apiPath: '/ecn/ecnReport/list',
      enumMainKey: '',
      companyNameKey: 'innerCustomerName',
      detailLink: '/mp/sale/ecn/detail',
      searchBarPlaceholder: '客户编码/名称、报告编码/标题',
      tabs: ['全部', '待审核', '已退回'],
      countApi: '/ecn/count',
      arrEnumField: [
        {
          mainKey: 'B02_Ecn_Report_Status',
          subKey: 'reportStatus',
          value: 'reportStatusName'
        }
      ],
      countTransform: (data, self) => {
        let { 3: a, 6: b } = data;
        setCount([undefined, a, b]);
      },
      tabConfig: [
        undefined, //全部
        3, // 待审核
        6 // 已退回
      ]
    }
  };

  const config = Config[props.type];
  const {
    companyCode,
    searchKey,
    inited,
    error,
    dataError,
    updateTs,
    currentTab,
    total,
    showLoading,
    list,
    count,
    setCount,
    handleTab,
    handleChange,
    handleClear,
    handleReset,
    self
  } = useList(props, config);

  //初始化默认企业
  useEffect(() => {
    self.init();
  }, [self]);

  //companyCode改变时执行
  useEffect(() => {
    self.getCount();
  }, [companyCode, self]);

  //根据依赖多次执行
  useEffect(() => {
    self.search();
  }, [searchKey, companyCode, currentTab, self]);

  self.beforeSearch = async function () {
    self.searchQueries = {
      reportStatus: config.tabConfig[currentTab]
    };
  };

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  return (
    <Page
      transition={false}
      ptr={false}
      onLoadMore={(resolveLoading, finish) => {
        self.pageResolveLoading = resolveLoading;
        if (list.length >= total) {
          finish();
        } else {
          self.search();
        }
      }}
      className="v2"
    >
      <TopNav
        inited={inited}
        onSubmit={handleChange}
        onCancel={handleClear}
        onClear={handleClear}
        defaultValue={searchKey}
        placeholder={config.searchBarPlaceholder}
      />
      <Panel>
        {dataError !== null ? (
          <Msg {...dataError} />
        ) : (
          <span>
            <div className="m-tab-container">
              <ul className="m-flex-box">
                {config.tabs.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      handleTab(index);
                    }}
                    className={
                      currentTab === index ? 'm-flex-item curr' : 'm-flex-item'
                    }
                  >
                    <span className="name">{item}</span>
                    {count[index] && (
                      <sup className="u-num">{count[index]}</sup>
                    )}
                  </li>
                ))}
              </ul>
            </div>
            <div className="list-total">{total}</div>
            <div className="m-details-item">
              <div className="details-item-content">
                {updateTs > 0 &&
                  list.map((item, index) => (
                    <Link
                      to={`${config.detailLink}/${companyCode}/${item.reportXkNo}`}
                      key={index}
                      className="content-line line-list-item"
                    >
                      <div className="line-list-item-title">
                        <span>{item.reportXkNo}</span>
                        <div className="more">
                          <span
                            className={
                              'u-sign ' +
                              CommonFns.getStatusClass('ECN', item.reportStatus)
                            }
                          >
                            {item.reportStatusName}
                          </span>
                        </div>
                      </div>
                      <ul className="field-list">
                        {self.isPurchase && (
                          <li>
                            <label>供应商</label>
                            <div>
                              {item.innerVendorName}({item.innerVendorCode})
                            </div>
                          </li>
                        )}
                        {!self.isPurchase && (
                          <li>
                            <label>客户</label>
                            <div>
                              {item.customerName}({item.innerCustomerCode})
                            </div>
                          </li>
                        )}
                        <li>
                          <label>报告标题</label>
                          <div>{item.reportTitle}</div>
                        </li>
                        <li>
                          <label>发布时间</label>
                          <div>
                            {formatDate(
                              item.reportPublishTime,
                              'YYYY-MM-DD HH:mm'
                            )}
                          </div>
                        </li>
                        <li>
                          <label>变更日期</label>
                          <div>
                            {formatDate(item.changeDate, 'YYYY-MM-DD HH:mm')}
                          </div>
                        </li>
                      </ul>
                    </Link>
                  ))}
                {!showLoading && list.length === 0 && (
                  <LoadMore showLine> 暂无数据</LoadMore>
                )}
              </div>
            </div>
          </span>
        )}
      </Panel>
      <Toast icon="loading" show={showLoading}>
        数据加载中...
      </Toast>
    </Page>
  );
}
EcnList.propTypes = {
  actions: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapDispatchToProps)(EcnList);
